<template>
  <div :class="[
      'position-relative vform-slide-control-element',
      tiles ? 'vform-image-tiles' : 'vform-image-no-tiles', config.alignment,
      config.noMarginBottom || (config.isInline && isTopBottomBar) ? 'no-margin-bottom' : 'mb-3',
      config.isInline && isTopBottomBar ? 'inline-element' : '',
      'height-mode-' + (heightMode ? 'height' : 'width')
      ]">
    <slot name="dropzone"></slot>
    <editor-overlay
        v-if="editable"
        :active="editorSelected"
        :can-have-template="false"
        @removeBlock="$emit('removeBlock')"
        @editProperty="editProperty"
        @editTemplate="editTemplate"
    />
    <preview
      v-if="getImage(config, lang)"
      :may-load-now="isActive"
      :preview-id="getImage(config, lang)"
      :size="config.size"
      :size-mode="heightMode ? 'height' : 'width'"
      source="asset"
      :asset-id="getImage(config, lang)"
      :removable="false"
      :class="['vform-image-display', config.alignment]"
      @preview="previewIsHere = true"
      :background-mode="false"
      :offline-mode="offlineMode"
      :show-spinner-message="false"
      @contentLoaded="increaseCounter"
     />
    <div class="text-center" v-else>
      {{ $t('noImageSelected') }}<br />
      <icon class="lighter" type="image" size="3" />
    </div>
  </div>
</template>

<script>
import ElementMixin from "@/components/vForm/mixins/ElementMixin.js.vue";
import Preview from "@/components/vForm/viewer/Preview";
import Icon from "../../Icon";
import EditorOverlay from "./EditorOverlay";
export default {
  name: "IMAGE",
  components: {
    Preview,
    Icon,
    EditorOverlay
  },
  mixins: [ElementMixin],
  props: {
  },
  data() {
    return {
      forceReRenderKey: 0,
      previewIsHere: false,
      tiles: false
    };
  },
  computed: {
    /**
     * True when the image is inside a top/bottom bar AND isInline is set.
     * In this mode 100% scaling = 100% of the panel height, and the image
     * floats alongside sibling elements horizontally.
     */
    heightMode() {
      return this.isTopBottomBar && !!this.config.isInline;
    }
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.tiles = this.isTiles(this.config);
        this.forceReRenderKey++;
      }
    }
  },
  beforeMount() {
    this.tiles = this.isTiles(this.config)
  },
  methods: {
    validate() {
        return true;
    },
    checkRequired() {
      return true;
    },
  }
}
</script>

<style lang="scss">
.vform-slide-control-element {
  max-width:100%;
  max-height:100%;
  &.height-mode-height {
    height: 100% !important;
  }
}
// shared styles for non-tiles AND tiles
.vform-image-tiles, .vform-image-no-tiles {
  .vform-image-display {
    max-width:100%;
    max-height:100%;
    img {
      width: 100%;
      height: auto;
      flex-shrink: 0;
      flex-grow: 0;
      min-width: 20px;
    }
  }
}

.vform-image-no-tiles {
  svg {
    justify-self: end;
    min-width: 20px;
  }
  &.center {
    justify-content: center;
  }
  &.right {
    justify-content: flex-end;
  }
}
.vform-image-tiles {
  .vform-image-display {
    display: flex;
    align-items: center;
    svg {
      min-width: 20px;
    }
  }
}
.max-height {
  max-height: 100%;
}
.vform-slide-control-element {
  max-width: 100%;
  max-height: 100%;
}
</style>